import React, { Component } from "react";
import { connect } from "react-redux";
import { useSearchParams } from "react-router-dom";
import classes from "./Login.module.css";
import * as actions from "../../../store/actions/auth";
import TwoFactorModal from "../TwoFactorModal/TwoFactorModal";

// Wrapper to use hooks with class component
function withRouter(Component) {
  return function WrappedComponent(props) {
    const [searchParams] = useSearchParams();
    return <Component {...props} searchParams={searchParams} />;
  };
}

class Authentication extends Component {

  state = {
    username: null,
    password: null
  }

  inputChangeHandler = (newValue, field) => {
    let newState = { ...this.state };
    newState[field] = newValue;
    this.setState(newState);
  }

  initiateLogin = (event) => {
    event.preventDefault()
    if (this.props.loading) return;

    const redirectUrl = this.props.searchParams.get("redirect");
    this.props.authenticate(this.state.username, this.state.password, redirectUrl);
  }

  render() {
    let error = (
      <div className={classes.errorContainer}>
        <p>{this.props.authError}</p>
      </div>
    )

    const showError = !this.props.requiresTwoFactor && this.props.authError != null;

    return (
      <div className={classes.pageContainer}>
        {/* 2FA Modal */}
        <TwoFactorModal />

        {/* Login Form */}
        <div className={classes.authContainer}>
          <h1 className={classes.signInLabel}>Sign in</h1>
          <form>
            <input
              type="email"
              placeholder="Username"
              autoComplete="username"
              className={classes.emailField}
              disabled={this.props.loading}
              onChange={(event) => this.inputChangeHandler(event.target.value, "username")} />
            <input
              type="password"
              placeholder="Password"
              autoComplete="current-password"
              className={classes.passwordField}
              disabled={this.props.loading}
              onChange={(event) => this.inputChangeHandler(event.target.value, "password")} />
            <button
              onClick={(event) => this.initiateLogin(event)}
              className={classes.signInButton}
              disabled={this.props.loading}>
              {this.props.loading ? <span className={classes.spinner}></span> : "Sign in"}
            </button>
          </form>
        </div>
        {showError ? error : null}
      </div>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    authError: state.auth.authError,
    loading: state.auth.loading,
    requiresTwoFactor: state.auth.requiresTwoFactor
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    authenticate: (email, password, redirectUrl) => dispatch(actions.authenticate(email, password, redirectUrl))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Authentication));
